import axios from '../utils/axios';

export default function getAllIntegrationRecs (adminId, params) {
    return axios.get(`/admin/${adminId}/ats-integrations/recruiters`, { params });
}